/** @jsx jsx */
import { jsx } from '@emotion/core';
import utils from '../../../utils';
import { SiteLink } from '../../../components';
import { tileStyle } from './productTileStyle';

export function ProductTile({ product }) {
  const s = tileStyle;
  const imageUrl = product.thumbnailUrl ? utils.site.resourcePath(product.thumbnailUrl) : '/assets/product-empty.png';
  //console.log("product : ", product)
  const productUrl = product.productUrl ? product.productUrl : `/products/${product.productSlug}`;
  const available = product.productStatus === 0;
  return (
    <div css={[s.tile]}>
      <SiteLink css={s.tileLink} to={productUrl}>
        <div css={s.prdImage}>
          <div css={s.bg} style={{ backgroundImage: utils.css.bgUrlStyle(imageUrl) }}></div>
        </div>
        <div css={s.body}>
          <div css={s.name}>
            {product.productName}
            {/* <div className="productTile__inlineRating">
              <div data-bv-show="inline_rating" data-bv-product-id={product.productCode}></div>
            </div> */}
          </div>
          {product.shortDesc && <div css={s.shortDes}>
            {product.shortDesc}
          </div>}

          <div css={s.price}>
            {
              !available ? product.productStatusText :
              product.priceTextOveriding ? product.priceTextOveriding : 'AU ' + utils.money.formatMoney(product.priceIncTax)
            }
          </div>

          <span css={s.button} className="productTile__button">{available ? 'Buy Now' : 'Make Enquiry'}</span>
        </div>
      </SiteLink>
    </div>
  )
}